import {MinMaxConfig} from 'libs/models/validation/validation';

export const wallSizeConfig: MinMaxConfig = {
    min: 100,
    max: 1000,
}
